import { DelegateEditData, DelegateEditDate, DelegationsDataInProgress, NewDelegationFormData } from '@/interfaces/delegate/delegateInterfaces';
import { Person } from '@/interfaces/person';
import { DelegateService } from '@/services/delegate/delegate.service';
import { PersonService } from '@/services/person/person.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ResultTypes, validateDatePickers } from '@/validators/datePickersStartToEnd';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { asyncScheduler, Observer } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';

@Component({
  selector: 'app-delegate-home',
  templateUrl: './delegate-home.component.html',
  styleUrls: ['./delegate-home.component.css'],
})

export class DelegateHomeComponent implements OnInit {
  DatePickersStatus = ResultTypes;
  updateDelegation: boolean = false;
  listDelegation: boolean = true;

  modalState: boolean = false;
  // cambiar despues
  delegationsInProgressNewData: Partial<DelegationsDataInProgress[]> = [];

  editFormValidations = {
    datesValidation: this.DatePickersStatus.NOT_ALL_PARAMS_ARE_READY,
    allFieldsCorrect: false,
  }

  delegateEditForm = new FormGroup({
    nameControl: new FormControl(''),
    startDateControl: new FormControl(),
    endDateControl: new FormControl(),
    undefinedEndControl: new FormControl(''),
  });

  editStartDateError: string = '';
  editEndDateError: string = '';

  selectedDelegationId: number = 0;

  selectedDelegation: DelegationsDataInProgress = {
    id: 0,
    name: '',
    rutDv: '',
    email: '',
    dateEnd: undefined,
    dateStart: new Date(),
  }

  selectedDelegationFormData: DelegateEditData = {
    name: '',
    id: '',
    endDate: '',
    startDate: '',
    undefinedEnd: false,
  };

  // Delegation jonathan

  newDelegationFormValidations = {
    datesValidation: this.DatePickersStatus.NOT_ALL_PARAMS_ARE_READY,
    allFieldsCorrect: false,
  }

  newDelegationForm = new FormGroup({
    nameControl: new FormControl(''),
    noteControl: new FormControl(''),
    startDateControl: new FormControl(new Date(2000, 0, 1)),
    endDateControl: new FormControl(new Date(2000, 0, 1)),
    undefinedEndControl: new FormControl(false),
  });

  newDelegationFormData: NewDelegationFormData = {
    id: '',
    name: '',
    note: '',
    startDate: '',
    endDate: '',
    undefinedEnd: false,
  };

  personData?: Person;

  personOptions: { id: string, value: string }[] = [];
  loadingPersonOptions: boolean = false;

  userData?: State;

  constructor(
    private delegateService: DelegateService,
    private personService: PersonService,
    private store: Store<StoreState>,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {

    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });

    const { startDateControl: editStartDateControl, endDateControl: editEndDateControl, undefinedEndControl: editUndefineEndControl } = this.delegateEditForm.controls;

    const editStartDate$ = editStartDateControl.valueChanges;
    editStartDate$.subscribe(this.updateObserverSetter('startDate'));

    const editEndDate$ = editEndDateControl.valueChanges;
    editEndDate$.subscribe(this.updateObserverSetter('endDate'));

    const editUndefinedEndCheck$ = editUndefineEndControl.valueChanges;
    editUndefinedEndCheck$.subscribe(this.updateObserverSetter('undefinedEnd'));

    /// ///////////////////////////////

    const { nameControl, noteControl, undefinedEndControl, startDateControl, endDateControl } = this.newDelegationForm.controls;
    const name$ = nameControl.valueChanges;
    name$.subscribe(this.newDelegationObserverSetter('name'));

    const userList$ = name$.pipe(
      throttleTime(600, asyncScheduler, { leading: false, trailing: true }),
      switchMap((value) => {
        this.loadingPersonOptions = true;
        return this.personService.getFilteredList(value);
      }),
    );
    userList$.subscribe((options) => {
      this.loadingPersonOptions = false;
      this.personOptions = options;
    });

    const note$ = noteControl.valueChanges;
    note$.subscribe(this.newDelegationObserverSetter('note'));

    const undefinedEndCheck$ = undefinedEndControl.valueChanges;
    undefinedEndCheck$.subscribe(this.newDelegationObserverSetter('undefinedEnd'));

    const endDate$ = endDateControl.valueChanges;
    endDate$.subscribe(this.newDelegationObserverSetter('endDate'));

    const startDate$ = startDateControl.valueChanges;
    startDate$.subscribe(this.newDelegationObserverSetter('startDate'));

  }

  getAllDelegations() {
    if (this.userData) {
      const data$ = this.delegateService.getDelegations(this.userData.mdmid);
      data$.subscribe((data) => {
        this.delegationsInProgressNewData = data;
      });
    }
  }

  updateObserverSetter = (name: string): Observer<any> => ({
    next: (val) => {
      this.selectedDelegationFormData[name] = val;
      this.verifyEditForm();
    },
    error: (err: any) => {
      this.verifyEditForm();
    },
    complete: () => {
      this.verifyEditForm();
    },
  })

  ngOnInit() {
    this.getAllDelegations();
    this.cdRef.detectChanges();
  }

  verifyEditForm() {
    const {
      startDate,
      endDate,
    } = this.selectedDelegationFormData;

    let allOk = true;

    const originalData = this.delegationsInProgressNewData.find((delegation) => {
      const delegationId = <number>(delegation?.id);
      return delegationId === this.selectedDelegationId;
    });

    if (originalData) {
      const { dateStart: originalStartDate, dateEnd: originalEndDate } = originalData;
      let comparisonOriginalEndDate;
      let comparisonEndDate;
      let editEndDateError = '';
      let editStartDateError = '';

      if (originalEndDate) {
        comparisonOriginalEndDate = originalEndDate.getTime();
      }
      if (endDate) {
        comparisonEndDate = (endDate as Date).getTime();
      }

      if (startDate && originalStartDate) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        // If date dont change
        if ((startDate as Date).getDate() === originalStartDate.getDate() && comparisonOriginalEndDate === comparisonEndDate) {
          allOk = false;
        }
        else if (startDate && endDate) {
          if (startDate >= endDate) {
            allOk = false;
            editEndDateError = 'Debe ingresar una fecha posterior a la fecha de inicio de la delegación. Por favor intenta con otra.';
          }
        }


        // If end date change
        if (comparisonOriginalEndDate !== comparisonEndDate) {
          if (comparisonEndDate && endDate) {
            if (endDate < currentDate) {
              allOk = false;
              editEndDateError = 'No puedes ingresar una fecha anterior a la fecha actual. Por favor intenta con otra.';
            }
          }
        }

      }

      this.editEndDateError = editEndDateError;
      this.editStartDateError = editStartDateError;

    }

    this.editFormValidations.allFieldsCorrect = allOk;
  }

  onEdit(selectedDelegationId: number | undefined) {

    const dataEdit = this.delegationsInProgressNewData.find((delegation) => {
      const delegationId = <number>(delegation?.id);
      return delegationId === selectedDelegationId;
    });

    if (dataEdit) {
      if (dataEdit.dateEnd) {
        dataEdit.dateEnd.setHours(0, 0, 0, 0);
      }
      if (dataEdit.dateStart) {
        dataEdit.dateStart.setHours(0, 0, 0, 0);
      }
    }

    if (dataEdit && selectedDelegationId) {
      this.selectedDelegation = dataEdit;
      this.updateDelegation = true;
      this.selectedDelegationId = selectedDelegationId;
    }

  }

  onSaveEdit(event: Event) {
    event.preventDefault();
    // const  initDate = this.delegateEditForm[].value
    // const  endDate =
    this.updateDelegation = false;
    // if(this.delegateEditForm.valid)  {

    // }
    //  this.delegateService.editDelegation()    //  this.delegationDataId = id

  }

  onEditStartDateChange(date: Date | undefined) {
    this.delegateEditForm.patchValue({ startDateControl: date });
  }

  onEditEndDateChange(date: Date | undefined) {
    this.delegateEditForm.patchValue({ endDateControl: date });
  }

  // Delegacion jonathan

  newDelegationObserverSetter = (name: string): Observer<any> => ({
    next: (val) => {
      this.newDelegationFormData[name] = val;
      this.verifyForm();
    },
    error: (err) => {

      this.verifyForm();
    },
    complete: () => {
      this.verifyForm();
    },
  });

  verifyForm() {
    const {
      startDate,
      endDate,
    } = this.newDelegationFormData;
    let undefinedEnd = false;
    if (endDate === undefined) undefinedEnd = true;

    let allOk = true;
    if (startDate !== '' && endDate !== '') {
      this.newDelegationFormValidations.datesValidation = validateDatePickers(<Date>startDate, <Date>endDate, undefinedEnd);
      if (this.newDelegationFormValidations.datesValidation !== this.DatePickersStatus.ALL_OK) allOk = false;
    }
    else {
      allOk = false;
    }

    if (!this.personData) allOk = false;

    this.newDelegationFormValidations.allFieldsCorrect = allOk;
  }

  onSelectPerson() {
    const id = <string>this.newDelegationFormData.id;
    const personData$ = this.personService.getPersonDataById(id);
    personData$.subscribe({
      next: (res) => {
        this.personData = res;
        this.verifyForm();
      },
    });
  }

  onChangeSelected() {
    this.personOptions = [];
    this.personData = undefined;
    this.newDelegationFormData.id = '';
    this.verifyForm();
  }

  handleStartDateChange(date: Date | undefined) {
    this.newDelegationForm.patchValue({ startDateControl: date });
  }

  handleEndDateChange(date: Date | undefined) {
    this.newDelegationForm.patchValue({ endDateControl: date });
  }

  showModalConfirmNewDelegation() {
    this.store.dispatch(modalShow({
      title: '¿Estás seguro de delegar tus aprobaciones?',
      text: `
      Si ya has revisado la información registrada y está correcta, continúa en Crear delegación.
      De lo contrario, ingresa Volver para revisar la información.
      `,
      acceptButtonText: 'Crear delegación',
      actionOnAccept: () => {
        if (this.userData) {
          // const id = <string>this.newDelegationFormData.id;
          if (this.personData) {
            const { email, mdmid } = this.personData;
            // primer dispatch
            this.store.dispatch(loaderAnimationShow());
            this.delegateService.createDelegation({
              requestorId: this.userData.mdmid.toString(),
              requestorToDelegateId: mdmid,
              email,
              comment: this.newDelegationFormData.note,
              dateStart: <Date>this.newDelegationFormData.startDate,
              dateEnd: <Date | undefined>this.newDelegationFormData.endDate,
            }).subscribe({
              next: () => {
                this.router.navigateByUrl('/delegate/success', {
                  state: {
                    email: this.personData?.email,
                  },
                });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      this.router.navigateByUrl('/delegate/failure', {
                        state: {
                          email: this.personData?.email,
                        },
                      });

                    }
                  },
                });

              },
              complete: () => {
                // segundo dispatch
                this.store.dispatch(loaderAnimationHide());
              },
            });
          }
        }
      },
    }));
  }
  // modal eliminacion
  showModalConfirmEliminationDelegation(id: number | undefined) {
    if (id === undefined) return;
    this.store.dispatch(modalShow({
      title: '¿Estás seguro de eliminar esta delegación?',
      text: `
      La delegación será eliminada automáticamente si continúa en eliminar delegación.
      Presiona Volver para regresar a la pantalla anterior.
      `,
      acceptButtonText: 'Eliminar delegación',
      actionOnAccept: () => {

        const personId = <number>id;
        this.store.dispatch(loaderAnimationShow());
        const dataDelete = this.delegationsInProgressNewData.find((delegation) => {
          const delegationId = <number>(delegation?.id);
          return delegationId === personId;
        });

        if (dataDelete) {

          if (this.userData) {

            const formResponse: DelegateEditDate = {
              delegateId: dataDelete.id,
              requestorId: this.userData.mdmid,
            };

            this.selectedDelegation = dataDelete;
            // this.updateDelegation = true;
            this.selectedDelegationId = id;
            this.delegateService.deleteDelegation(formResponse)
              .subscribe({
                next: () => {
                  this.getAllDelegations();
                },
                error: () => {
                  this.store.dispatch(loaderAnimationHide());
                },
                complete: () => {
                  // segundo dispatch
                  this.store.dispatch(loaderAnimationHide());
                },
              });
          }
        }
      },
    }));
  }

  onDelegatePersonTextChange(value: string) {
    this.newDelegationForm.patchValue({ nameControl: value });
  }

  setDelegatePersonId(value: string) {
    this.newDelegationFormData.id = value;
  }

  showModalConfirmEditDelegation() {

    this.store.dispatch(modalShow({
      title: '¿Estás seguro de modificar esta delegación?',
      text: `
        Si ya has revisado la información registrada y está correcta, continúa en modificar delegación.
        De lo contrario, ingresa volver para revisar la información.
        `,
      acceptButtonText: 'Modificar delegación',

      actionOnAccept: () => {
        const form = this.selectedDelegationFormData;

        if (this.userData) {
          // console.warn(userData)
          if (this.selectedDelegation.id) {

            const formResponse: DelegateEditDate = {
              delegateId: +this.selectedDelegation.id,
              requestorId: this.userData.mdmid,
              dateStart: <Date>form.startDate,
              dateEnd: <Date>form.endDate,
            };
            // primer dispatch
            this.store.dispatch(loaderAnimationShow());

            this.delegateService.editDelegation(formResponse)
              .subscribe({
                next: () => {
                  this.updateDelegation = false;

                  this.delegateEditForm.patchValue({ nameControl: '', startDateControl: '', endDateControl: '' });

                  this.getAllDelegations();
                },
                error: (error) => {
                  this.editEndDateError = error.error.replace('solicitud', 'delegación');
                  this.store.dispatch(loaderAnimationHide());
                },
                complete: () => {
                  // segundo dispatch
                  this.store.dispatch(loaderAnimationHide());
                },
              });
          }
        }
      },
    }));
  }

}
